import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from './service/api.service';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import moment from 'moment';
import { CommonService } from './service/common.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxUiLoaderModule],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  latitude!: number;
  longitude!: number;
  city: string = '';
  
  entryTime: Date | null = null;
  currentUrl: string = '';
  userIp: string = '';
  constructor(
    private api: ApiService,
    private router: Router,
    private common: CommonService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      if (typeof localStorage !== 'undefined' && !localStorage.getItem('city')) {
        let obj = {
          city: 'Lucknow',
          country: 'India',
          country_code: 'in',
          postcode: '226017',
          state: 'Utter Pardesh',
        };
        localStorage.setItem('city', JSON.stringify(obj));
      }

      if (typeof sessionStorage !== 'undefined') {
        const cachedIp = sessionStorage.getItem('user_ip');
        if (cachedIp) {
          this.userIp = cachedIp;
        }
      }

      // Defer third-party external calls (IP check) so they never block initial page load
      const deferIp = () => {
        if (!this.userIp) {
          this.getUserIP();
        }
      };

      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => setTimeout(deferIp, 2500));
      } else {
        setTimeout(deferIp, 3500);
      }

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.currentUrl && this.entryTime) {
            this.setPageVisit(this.currentUrl, this.entryTime, new Date(), false);
          }
        } else if (event instanceof NavigationEnd) {
          this.currentUrl = window.location.href;
          this.entryTime = new Date();
          if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            if (document.documentElement) document.documentElement.scrollTop = 0;
            if (document.body) document.body.scrollTop = 0;
            const sidenav = document.querySelector('mat-sidenav-content, .mat-sidenav-content');
            if (sidenav) sidenav.scrollTop = 0;
            requestAnimationFrame(() => {
              window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
              if (document.documentElement) document.documentElement.scrollTop = 0;
              if (document.body) document.body.scrollTop = 0;
              if (sidenav) sidenav.scrollTop = 0;
            });
          }
        }
      });
    }
  }

  getUserLocation() {
    this.api.getAccurateLocation().then(
      (coords) => {
        this.latitude = coords.latitude;
        this.longitude = coords.longitude;
        this.api
          .getAddressFromCoordinates(this.latitude, this.longitude)
          .subscribe(
            (data: any) => {
              this.city = data.address;
              localStorage.setItem('city', JSON.stringify(this.city));
            },
            (error) => {
              let obj = {
                city: 'Lucknow',
                country: 'India',
                country_code: 'in',
                postcode: '226017',
                state: 'Utter Pardesh',
              };
              localStorage.setItem('city', JSON.stringify(obj));
            }
          );
      },
      (error) => {
        let obj = {
          city: 'Lucknow',
          country: 'India',
          country_code: 'in',
          postcode: '226017',
          state: 'Utter Pardesh',
        };
        localStorage.setItem('city', JSON.stringify(obj));
      }
    );
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.currentUrl && this.entryTime) {
      this.setPageVisit(this.currentUrl, this.entryTime, new Date(), true);
    }
  }

  getUserIP() {
    if (typeof window !== 'undefined') {
      fetch('https://api.ipify.org?format=json')
        .then(res => res.json())
        .then(data => {
          this.userIp = data.ip;
          if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('user_ip', data.ip);
          }
        })
        .catch(err => console.log('Could not get IP', err));
    }
  }

  setPageVisit(url: string, entryTime: Date, exitTime: Date, isUnload: boolean) {
    if (!isPlatformBrowser(this.platformId) || typeof localStorage === 'undefined') return;
    let userData: any;
    const durationInSeconds = Math.floor((exitTime.getTime() - entryTime.getTime()) / 1000);
    const u: any = localStorage.getItem('userData');
    if (u) {
      userData = JSON.parse(u || null);
    }
    const city = this.common.getLocation()?.city || '';
    const body = {
        user_id: `${userData?.id ?? ''}`,
        page_url: `${url}`,
        city: city,
        vehicleId: '',
        entry_time: moment(entryTime.toISOString()).format("HH:mm:ss"),
        exit_time: moment(exitTime.toISOString()).format("HH:mm:ss"),
        duration: durationInSeconds,
        ipAdd: this.userIp,
        is_unload: isUnload ? 'true' : 'false'
    };

    this.api.commonPost('page-visit', body).subscribe((res: any) => {});
  }
}
